import axios from "axios";

const baseUrl = process.env.REACT_APP_DIFLEX_API_URL + "/billing";

export const getOverviewData = async (filters, apiAccessToken) => {
  try {
    const response = await axios.post(
      `${baseUrl}/Overview/get-overview-data`,
      filters,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch overview data"
    );
  }
};

export const getOfficeBranches = async (apiAccessToken) => {
  try {
    const response = await axios.get(
      `${baseUrl}/Overview/get-office-branches`,
      {
        headers: {
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch office branches"
    );
  }
};

export const getAgreementNames = async (apiAccessToken) => {
  try {
    const response = await axios.get(
      `${baseUrl}/Overview/get-agreement-names`,
      {
        headers: {
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch agreement names"
    );
  }
};

export const getBillingGroupNames = async (apiAccessToken) => {
  try {
    const response = await axios.get(
      `${baseUrl}/Overview/get-billing-group-names`,
      {
        headers: {
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch billing group names"
    );
  }
};
